// Shared partial-reload manifest for call-detail mutations
// (CON-195). After a disposition / deal / summary-note edit
// or a follow-up create/complete from the CallDetailPanel,
// every surface partial-reloads the same prop set so the
// server's serializers stay the single source of truth.
//
// Inertia `only:` keys are snake_case server-side names.
// Inertia silently ignores props absent on the current page,
// so the same manifest works whether the panel is mounted on
// the inbox (`thread`), a deal/contact show (`activity`), or
// inside the slideover (`drawer`). `timeline` is the spine
// payload some surfaces ship (CON-180).
export const CALL_DETAIL_RELOAD_PROPS = [
  "activity",
  "timeline",
  "drawer",
  "thread",
] as const
